import { FileTextOutlined } from '@ant-design/icons'
import { useRequest } from 'ahooks'
import { Collapse, CollapsePanelProps, List, Progress, Tooltip, Typography } from 'antd'
import { round } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useHistory } from 'react-router-dom'

import { RiskBar } from '@/components'
import { routes } from '@/router'
import { ga, traceEvent } from '@/utils/ga'

import { Customer, CustomerFlowStatus } from '../customer/customer.schema'
import { PlanDate } from './plan-date.component'
import { Switch } from './switch.component'

const { Text } = Typography

export const MyCustomer: React.FC<CollapsePanelProps> = (props) => {
  const { t } = useTranslation()
  const [searchType, setSearchType] = React.useState(1)
  const history = useHistory()

  const { data, loading } = useRequest<{ count: number; list: Customer[] }>(
    {
      url: '/api/customer/mine',
      params: {
        searchType,
      },
    },
    {
      refreshDeps: [searchType],
    }
  )

  const options = [
    { label: t('owner'), value: 1, name: '负责' },
    { label: t('join in'), value: 2, name: '参与' },
  ]

  const onChange = (searchType: number) => {
    setSearchType(searchType)
  }

  if (!data?.count) {
    return null
  }

  const header = (
    <>
      <span>{props.header}</span>
      <Switch options={options} value={searchType} onChange={onChange} />
    </>
  )

  return (
    <Collapse.Panel {...props} header={header}>
      <List
        className='max-h-600px overflow-y-auto'
        itemLayout='horizontal'
        loading={loading}
        size='small'
        bordered
        locale={{ emptyText: <div className='text-left'>我的{t('customer.title')}在此展示</div> }}
        dataSource={data?.list || []}
        renderItem={(customer) => (
          <List.Item className='space-x-24px'>
            <Text className='flex-grow flex'>
              <RiskBar className='mr-20px' risk={customer.risk} />
              <Link
                to={routes.customer.detail(customer.selfId)}
                onClick={() => {
                  ga('event', traceEvent.personalPage.events.click_check_detail, {
                    event_category:
                      searchType === 1
                        ? traceEvent.personalPage.event_categories.ef_pmo_home_my_customers_owner
                        : traceEvent.personalPage.event_categories.ef_pmo_home_my_customers_member,
                    action: traceEvent.personalPage.action,
                    event_label: customer.name,
                    target: traceEvent.personalPage.targets.ef_pmo_customer_detail,
                  })
                  window.sessionStorage.setItem('entry', traceEvent.detailPage.event_categories.ef_pmo_customers)
                }}
              >
                {customer.name}
              </Link>
            </Text>
            {customer.flowStatus === CustomerFlowStatus.研发未开始 && (
              <Tooltip title={customer.thisWeekReport ? t('view report') : t('report.gowrite')}>
                <FileTextOutlined
                  className={customer.thisWeekReport ? 'text-blue-600' : 'text-red-600'}
                  onClick={() => history.push(routes.customer.detail(customer.selfId, { tab: 'report' }))}
                />
              </Tooltip>
            )}
            <Progress
              className='font-mono flex-shrink-0'
              type='circle'
              width={26}
              percent={round(customer.progress, 0)}
            />

            <PlanDate date={customer.endDate as any as string} tooltip={t('end')} />
          </List.Item>
        )}
      />
    </Collapse.Panel>
  )
}
